module.exports = __webpack_public_path__ + "img/9.ab7a27a5.png";